import { render, staticRenderFns } from "./MapGetPoint.vue?vue&type=template&id=af83e956&scoped=true&"
import script from "./MapGetPoint.vue?vue&type=script&lang=js&"
export * from "./MapGetPoint.vue?vue&type=script&lang=js&"
import style0 from "./MapGetPoint.vue?vue&type=style&index=0&id=af83e956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af83e956",
  null
  
)

export default component.exports